import React, { FC } from "react";
import { Cell, Grid } from "baseui/layout-grid";
import { mergeOverrides } from "baseui";
import { TableBuilder, TTableView } from "kanopi-components/TableView/TableView";
import { useStyletron } from "kanopi-components/theme/useStyletron";
import { useUnderBreakpoint } from "kanopi-components/useUnderBreakpoint";
import { LabelSmall } from "kanopi-components/typography";

type TSummaryTable = {
  data: unknown[];
  chunks?: number;
  columns?: number;
  type?: string;
  emptyMessage?: string;
} & TTableView;
export const SummaryTable: FC<TSummaryTable> = ({
  data,
  columnSchema = [],
  chunks,
  columns,
  type = "SUMMARY",
  overrides,
  emptyMessage = "No data found",
  ...restProps
}) => {
  const isNotDesktop = useUnderBreakpoint("large");
  const [, theme] = useStyletron();
  const defaultColumns = data?.length > 5 ? 2 : 1;
  const defaultChunks = data?.length > 5 ? 2 : 1;
  const defaultColumnSchema = [
    {
      header: "",
      id: "label",
      children: (row) => row?.label,
      sortable: false,
      overrides: {
        TableBodyCell: {
          style: () => ({
            whiteSpace: "nowrap",
            paddingLeft: 0,
            ...theme.typography.LabelSmall,
          }),
        },
      },
    },
    {
      header: "",
      id: "value",
      children: (row) => row?.value,
      sortable: false,
      overrides: {
        TableBodyCell: {
          style: () => ({
            width: "100%",
            ...theme.typography.ParagraphSmall,
          }),
        },
      },
    },
  ];
  const chunkArray = (arr = [], chunkSize) => {
    const chunks = [];
    const _chunkSize = Math.ceil(arr.length / chunkSize);
    for (let i = 0; i < arr.length; i += _chunkSize) {
      const chunk = arr.slice(i, i + _chunkSize);
      chunks.push(chunk);
    }
    return chunks;
  };

  const chunkData = chunkArray(data, isNotDesktop ? 1 : chunks || defaultChunks) || [];
  return data?.length > 0 ? (
    <Grid
      gridMargins={0}
      gridMaxWidth="100%"
      overrides={{
        Grid: {
          props: {
            "data-testid": `summaryTable-${type}`,
          },
        },
      }}
    >
      {chunkData.map((chunk, index) => (
        <Cell key={index} span={12 / (isNotDesktop ? 1 : columns || defaultColumns)}>
          <TableBuilder
            columnSchema={columnSchema.length > 0 ? columnSchema : defaultColumnSchema}
            data={chunk}
            showPagination={false}
            showSearchSection={false}
            striped={false}
            {...restProps}
            overrides={mergeOverrides(
              {
                TableHead: {
                  style: {
                    display: "none",
                  },
                },
                TableBodyRow: {
                  style: {
                    ":first-child td": {
                      borderTopWidth: theme.borders.border300.borderWidth,
                      borderTopStyle: theme.borders.border300.borderStyle,
                      borderTopColor: theme.borders.border300.borderColor,
                    },
                  },
                },
              },
              overrides
            )}
          />
        </Cell>
      ))}
    </Grid>
  ) : (
    <LabelSmall>{emptyMessage}</LabelSmall>
  );
};
